module.exports = __webpack_public_path__ + "static/media/trust-shipment.58160dcf.svg";